import { render, staticRenderFns } from "./ColorCalibrationPn.vue?vue&type=template&id=35fb59a8&scoped=true&"
import script from "./ColorCalibrationPn.vue?vue&type=script&lang=js&"
export * from "./ColorCalibrationPn.vue?vue&type=script&lang=js&"
import style0 from "./ColorCalibrationPn.vue?vue&type=style&index=0&id=35fb59a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb59a8",
  null
  
)

export default component.exports